export const ACTION_SET_LIST_USER            = 'ACTION_SET_LIST_USER';
export const NOTIFICATIONS                   = 'NOTIFICATIONS';
export const CAMPANA                         = 'CAMPANA';

//ENCUESTAMULTIPLE
